import { Injectable } from '@angular/core';
import { ApiService, BaseApiService } from '@fc-core/services/base-api.service';
import { Hardware } from '@fc-core/models';
import { expand, map } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
@ApiService({
  baseName: 'hardware',
})
export class HardwareApiService extends BaseApiService {
  constructor(private http: HttpClient) {
    super();
  }

  static fromJSON(res: any): Hardware {
    return res;
  }

  // TODO: replace hand-rolled pagination loop with fetchAllPages (@fc-shared/utils/request-utils/fetch-all-pages)
  loadAll(): Observable<Hardware[]> {
    return this.http.get(this.getUrl()).pipe(
      expand((results: any) => {
        if (!!results['next']) {
          return this.http.get(results['next']);
        } else {
          return EMPTY;
        }
      }),
      map((res: any) => res['results']),
      map((res): Hardware[] => {
        return res.map((hardware: any) =>
          HardwareApiService.fromJSON(hardware),
        );
      }),
    );
  }

  load(id: number): Observable<Hardware> {
    return this.http.get<Hardware>(this.getUrl(id)).pipe(
      map((res: Hardware): Hardware => {
        return HardwareApiService.fromJSON(res);
      }),
    );
  }

  search(
    search: string,
    assigned: boolean,
    vehicle_id?: number,
  ): Observable<Hardware[]> {
    let params: HttpParams = new HttpParams()
      .set('search', search)
      .set('assigned', assigned ? 'true' : 'false')
      .set('ordering', 'serial');

    if (vehicle_id) {
      params = params.set('vehicle_id', vehicle_id + '');
    }

    return this.http
      .get(this.getUrl(), {
        params: params,
      })
      .pipe(
        map((res: any) => res['results']),
        map((res: Hardware[]): Hardware[] => {
          return res.map((hw) => HardwareApiService.fromJSON(hw));
        }),
      );
  }

  validateHardware(serial: string, vehicleId?: number): Observable<Hardware> {
    let params: HttpParams = new HttpParams();
    if (vehicleId) params = params.append('vehicle_id', vehicleId);
    return this.http.get<Hardware>(this.getUrl() + `s/${serial}/validate/`, {
      params,
    });
  }
}
